import React from "react";

const siddhi_pawar = () => {
  return (
    <div>
      <h1>Siddhi Pawar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The shortlisting was based on Online Simulation and Codility
        Assessments. Students with a CGPA above 7 were eligible.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        <strong>18 August:</strong> Aptitude Round
        <br />
        <strong>26 August:</strong> Interviews (2 Rounds - Technical and HR)
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        There were 2 rounds -<br />
        Online Simulation Round: Questions on English grammar, logical
        reasoning, and verbal ability.
        <br />
        Coding Round: Three coding questions — two medium-level (based on arrays
        and strings) and one hard-level (based on graphs).
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        16 students got shortlisted for interviews
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was announced on 22 August, and the interviews were
        scheduled for 26 August. During this period, I was also shortlisted for
        the Mastercard Hackathon on 25 August. To prepare, I repeatedly went
        through my resume and projects, revised core computer science subjects
        such as OOPs, OS, and DBMS, and practiced medium-level DSA questions
        that I had previously solved from Striver’s sheet.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        <strong>Technical Round:</strong> Two panels were formed with 8 students
        each. After this round, 5 students were shortlisted for the HR round.
        The interview focused on DSA, OOPs, DBMS, and puzzles.
        <br />
        <strong>HR Round:</strong> Focused on general questions and role
        discussion.
        <br />
        Eventually, all 5 students selected for the HR round were shortlisted
        for the summer internship.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        <strong>Technical Round:</strong> Began with a brief introduction,
        followed by DSA questions on Binary Search Trees and recursion. I was
        also asked two train puzzles, basic OOPs questions on polymorphism and
        static binding, and a DBMS query.
        <br />
        were particularly looking for students with hands-on experience in Java.
        <br />
        <strong>HR Round:</strong> Included basic HR questions, reasons for
        choosing HSBC, role discussion, technical interview experience, and
        leadership experience during the Mastercard Hackathon.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Love Babbar - DMBS, OS
        <br />
        450 DSA Cracker
        <br />
        Striver SDE sheet
        <br />
        GeeksforGeeks and Interview Bit for last minute prep
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        The coding questions asked were fairly simple. Make sure your basics are
        clear and well-practised.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Since I mentioned my extracurricular activities during the introduction,
        they asked one follow-up question about that. No other questions were
        asked in this area.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Don’t panic at any point. In my case, I didn’t receive the OA link on
        time while others had already started their test. I had almost given up,
        but eventually received the link after quite a delay, attempted the
        test, and got shortlisted. Keep working on projects, practice a lot of
        DSA problems, and keep your basics strong.{" "}
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <p>
        Stay consistent and trust your preparation. It’s completely normal to
        feel nervous or uncertain during the process, but don’t let that shake
        your confidence. Focus on understanding concepts rather than memorizing
        them, and keep revising your core subjects regularly. Practice coding
        daily even solving one problem a day can make a big difference over
        time.
      </p>

      <p>
        Also, don’t compare your progress with others; everyone has their own
        journey. Believe in your abilities, stay positive, and keep learning
        opportunities will come your way when you’re prepared for them.
      </p>

      <p>
        If you ever need guidance or support during your preparation, feel free
        to reach out to me via email , I’ll be happy to help.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong>{" "}
        <a href="mailto:pawarsv23.comp@coeptech.ac.in">
          pawarsv23.comp@coeptech.ac.in
        </a>
      </p>

      <hr />
    </div>
  );
};

export default siddhi_pawar;
